/**
 * Dark-aware surface tokens for the student portal.
 * Values flip when AdminThemeProvider sets `data-theme="dark"` on <html>.
 */
import { studentPalette } from "./studentPalette";

export const studentSurfaces = {
  canvas: "var(--surface-canvas)",
  raised: "var(--surface-raised)",
  muted: "var(--surface-muted)",
  text: "var(--text-primary)",
  textMuted: "var(--text-muted)",
  border: "var(--border-subtle)",
};

/** Outline buttons on dark cards — filled maroon for readability */
export const studentOutlineButtonDarkSx = {
  "html[data-theme='dark'] &": {
    bg: studentPalette.secondary,
    borderColor: studentPalette.secondary,
    color: studentPalette.cream,
  },
  "html[data-theme='dark'] &:hover": {
    bg: studentPalette.wine,
    borderColor: studentPalette.wine,
    color: studentPalette.cream,
  },
};

/** Chakra MenuItemOption — readable hover/focus in light and dark mode */
export const studentMenuItemOptionSx = {
  color: studentPalette.primary,
  bg: "transparent",
  fontWeight: "600",
  _hover: {
    bg: "rgba(91, 13, 22, 0.1)",
    color: studentPalette.primary,
  },
  _focus: {
    bg: "rgba(91, 13, 22, 0.1)",
    color: studentPalette.primary,
  },
  "html[data-theme='dark'] &": {
    color: "var(--text-primary)",
    _hover: {
      bg: `${studentPalette.wine} !important`,
      color: `${studentPalette.cream} !important`,
      "& .chakra-text": {
        color: `${studentPalette.cream} !important`,
      },
    },
    _focus: {
      bg: `${studentPalette.wine} !important`,
      color: `${studentPalette.cream} !important`,
      "& .chakra-text": {
        color: `${studentPalette.cream} !important`,
      },
    },
  },
};
